import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import { useDetailHub } from "hooks/hub-management/useHub";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useParams } from "react-router-dom";
import DetailForm from "./DetailForm";

const UpdateHub = () => {
  const { id } = useParams();
  const { t } = useTranslation(["hub"]);

  const {
    isLoading,
    data: hubDetail,
    refetch: refetchHubDetail,
  } = useDetailHub({
    hubId: id,
    params: {
      expand: "province_name,district_name,ward_name,parent_hub",
    },
  });

  useEffect(() => {
    refetchHubDetail();
  }, []);

  return (
    <div className="page-content">
      <MetaTags>
        <title>{t("title.update")}</title>
      </MetaTags>
      <div className="container-fluid">
        <BreadcrumbWithLink
          title={t("title.update")}
          breadcrumbItems={[
            { name: t("title.manager") },
            { name: t("title.list", { target: t("hub") }), link: "/hub/list" },
            { name: t("title.update") },
          ]}
        />
        {isLoading ? (
          <LoadingFormNormal
            countInput="6"
            countButton="1"
            formClass="row-cols-1 row-cols-md-2"
            buttonClass="justify-content-start"
            buttonColClass="col-3"
          />
        ) : (
          <DetailForm detail={hubDetail} />
        )}
      </div>
    </div>
  );
};

export default UpdateHub;
